// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__pSdB9","linksWrapper":"About_linksWrapper__ykYXy","acCard":"About_acCard__ccg5B","infoWrapper":"About_infoWrapper__dpV87"};